import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function Register() {
  const { register, formatApiError } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await register(form);
      toast.success("Account created! Welcome to Saad IPTV.");
      navigate("/dashboard");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center px-4 py-10">
      <div className="sadd-aurora" />
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8"><Logo /></div>
        <div className="glass rounded-2xl p-8">
          <h1 className="font-heading text-2xl font-bold text-white mb-1">Create your account</h1>
          <p className="text-sm text-slate-400 mb-6">Start streaming in minutes</p>
          {error && <div data-testid="register-error" className="mb-4 text-sm text-red-400 bg-red-500/10 border border-red-500/20 rounded-lg px-4 py-2">{error}</div>}
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label className="text-slate-300">Full Name</Label>
              <Input data-testid="register-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
                className="mt-1.5 bg-white/5 border-white/10 text-white" placeholder="John Doe" />
            </div>
            <div>
              <Label className="text-slate-300">Email</Label>
              <Input data-testid="register-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
                className="mt-1.5 bg-white/5 border-white/10 text-white" placeholder="you@example.com" />
            </div>
            <div>
              <Label className="text-slate-300">Phone (optional)</Label>
              <Input data-testid="register-phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })}
                className="mt-1.5 bg-white/5 border-white/10 text-white" placeholder="+1 555 000 0000" />
            </div>
            <div>
              <Label className="text-slate-300">Password</Label>
              <Input data-testid="register-password" type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
                className="mt-1.5 bg-white/5 border-white/10 text-white" placeholder="Min 6 characters" />
            </div>
            <Button data-testid="register-submit" type="submit" disabled={loading} className="w-full glow-btn bg-gradient-to-r from-purple-600 to-blue-600 text-white border-0">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Create Account"}
            </Button>
          </form>
          <p className="text-sm text-slate-400 mt-6 text-center">
            Already have an account? <Link to="/login" className="text-neon-purple hover:underline">Login</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
